import { SignedUrlService } from '@workspaces/services'
import { Metadata, Environment } from '@workspaces/types'

export default {
  async uploadFileToBucketViaSignedUrl(
    meta: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
    bucketName: string,
    fileName: string,
    file: File,
    extraHeaders: Record<string, string> = {},
  ): Promise<void> {
    const signedUrl = await SignedUrlService.getSignedUrlForFile(
      meta,
      environment,
      fileName,
      bucketName,
      file.type,
      'write',
    )

    if (!signedUrl) {
      throw new Error(
        'Failed to upload file: Failed to get signed URL for file upload',
      )
    }

    // Extra headers must match what the backend included in the v4 signature
    // (e.g. Cache-Control for poi-icons), or GCS rejects the PUT.
    const response = await fetch(signedUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'content-type': file.type,
        ...extraHeaders,
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to upload file: ${response.statusText}`)
    }
  },

  async getDownloadUrlForAttachment(
    meta: Metadata.AppMetadata,
    environment: Environment.EnvironmentResolver,
    bucketName: string,
    fileName: string,
    type: string,
  ): Promise<string> {
    return SignedUrlService.getSignedUrlForFile(
      meta,
      environment,
      fileName,
      bucketName,
      type,
      'read',
    )
  },
}
